if (!customElements.get('variant-dropdown-quick-add')) {
  customElements.define(
    'variant-dropdown-quick-add',
    class VariantDropdownQuickAdd extends HTMLElement {
      constructor() {
        super();
        
        this.button = this.querySelector('.variant-dropdown__toggle');
        this.dropdown = this.querySelector('.variant-dropdown__list');
        this.form = this.querySelector('form');
        this.variantIdInput = this.form.querySelector('[name="id"]');
        this.submitButton = this.form.querySelector('[type="submit"]');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        
        this.button.addEventListener('click', this.toggleDropdown.bind(this));
        this.dropdown.addEventListener('click', this.onVariantSelect.bind(this));
        
        // Close dropdown when clicking outside
        document.addEventListener('click', (evt) => {
          if (!this.contains(evt.target)) {
            this.closeDropdown();
          }
        });
      }

      toggleDropdown(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        
        const isOpen = this.dropdown.classList.contains('active');
        
        // Close all other dropdowns
        document.querySelectorAll('.variant-dropdown__list.active').forEach(dropdown => {
          dropdown.classList.remove('active');
          dropdown.closest('.variant-dropdown-quick-add').classList.remove('dropdown-open');
        });
        
        if (!isOpen) {
          this.dropdown.classList.add('active');
          this.classList.add('dropdown-open');
          this.button.setAttribute('aria-expanded', 'true');
        } else {
          this.closeDropdown();
        }
      }

      closeDropdown() {
        this.dropdown.classList.remove('active');
        this.classList.remove('dropdown-open');
        this.button.setAttribute('aria-expanded', 'false');
      }

      onVariantSelect(evt) {
        const variantOption = evt.target.closest('.variant-dropdown__option');
        if (!variantOption || variantOption.classList.contains('disabled')) return;
        
        evt.preventDefault();
        evt.stopPropagation();
        
        const variantId = variantOption.dataset.variantId;
        const variantTitle = variantOption.dataset.variantTitle;
        
        // Update hidden input
        this.variantIdInput.value = variantId;
        
        // Update button text
        this.button.querySelector('.variant-dropdown__selected').textContent = variantTitle;
        
        // Close dropdown
        this.closeDropdown();
        
        // Add to cart
        this.addToCart();
      }

      addToCart() {
        this.button.setAttribute('aria-disabled', 'true');
        this.button.classList.add('loading');
        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              // Handle error
              console.error('Error adding to cart:', response.description);
              this.handleError(response.description);
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            // Success - update cart
            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'variant-dropdown-quick-add',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            }
            
            this.error = false;
            this.cart.renderContents(response);
            
            // Reset button text after a delay
            setTimeout(() => {
              this.button.querySelector('.variant-dropdown__selected').textContent = 'Choose Options';
            }, 2000);
          })
          .catch((e) => {
            console.error(e);
            this.handleError('An error occurred. Please try again.');
          })
          .finally(() => {
            this.button.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }
            if (!this.error) {
              this.button.removeAttribute('aria-disabled');
            }
            if (spinner) spinner.classList.add('hidden');
          });
      }

      handleError(errorMessage) {
        this.error = true;
        alert(errorMessage); // You can replace this with a more elegant error display
      }
    }
  );
}